/**
 * The request tracker's verification funnel through GET /api/release-notes-funnel (M263): how many
 * shipped requests still wait on a confirmation, counted server-side over every request (not the
 * page's filtered list). Server side: api src/data/tracker-funnel.ts.
 *
 * Read by the Requests page (the client's "Confirm these (n)" banner, the dev's tile) and the
 * sidebar badge. The key sits under release_notes' list prefix, so the status change a request's
 * panel or board makes (useUpdateReleaseNotes invalidates releaseNotesKeys.lists()) refetches it.
 */

import { useQuery } from '@tanstack/react-query';
import { httpClient } from '../../http-client';

export interface TrackerFunnel {
  /** Verified by AIG, client-facing: waiting on the client's confirmation. */
  needs_confirmation: number;
  /** Deployed or Verified, client-facing, in that status for more than `stale_days` days. */
  stale_unconfirmed: number;
  stale_days: number;
  /** DEV only: deployed internal items AIG has not verified. */
  aig_internal_unverified?: number;
}

export const trackerFunnelKey = ['release_notes', 'list', 'funnel'] as const;

export function useTrackerFunnel(enabled = true) {
  return useQuery<TrackerFunnel>({
    enabled,
    queryKey: trackerFunnelKey,
    queryFn: async () => (await httpClient.get<{ data: TrackerFunnel }>('/release-notes-funnel')).data,
  });
}
